import  { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { getMedicoInt, ActualizaMedico } from "../../services/medico";
import { ErrorContext } from "../../utils/context/error";
import { getUsuarioFind } from "../../services/user";

function MedicoModal({ show, AreaI, AreaFId, UsuarioI, Tag, handleshow, handleFiltrar }) {

  const [habilita, setHabilita] = useState(false);
  const [areaId, setAreaId] = useState(0);
  const [usuarioId, setUsuarioId] = useState(0);
  const [activa, setActiva]= useState(false);
    
  const [area, setArea] = useState([]);
  const [data, setData] = useState([]);
  const [Titulo, setTitulo] = useState("");
  const [nombreMed, setNombreMed] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();
  let timeout="";
  
  //Boton Cancelar
  const handleCancel = async () => 
    {
      handleshow(false);
    };
   
  // Boton Aceptar
  const handleAceptar = async () => 
    {
       setHabilita(true);
       setShowToast(false);
       const response = await ActualizaMedico({
          areaId,
          usuarioId,
          Tag
        });
        if (response) 
          {
             if (response.status === 200) 
              {
                 handleFiltrar(AreaFId);
                 handleshow(false);
              } 
             else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
         else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             } 
        setHabilita(false);
    };

  const handlefilas=(item)=>
    {
     setNombreMed(item.NombreUsr);
     setUsuarioId(item.UsuarioId);
     setData([]);
    }  


    // Medico por Area e Id
    const fillMedicoInt = async (AreaId, UsuarioId) => 
      {
        
        setShowToast(false);
        const response = await getMedicoInt(AreaId, UsuarioId);
        if (response) 
          {
            if (response.status === 200) 
              {
                setArea(response.data.area);
                setNombreMed(response.data.data[0].NombreUsr)
                setUsuarioId(response.data.data[0].MedicoId);
              } 
            else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
        else
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true); 
        }  
     };
   
    useEffect(() => 
      {
         if (show) 
          {
            setAreaId(AreaI);
            setUsuarioId(UsuarioI);
            fillMedicoInt(AreaI, UsuarioI);
            if (Tag !== 0) 
              {
                 if (Tag === 1) setTitulo("Editar Medico (" + UsuarioI + ")");
                 if (Tag === 2) setTitulo("Eliminar Medico (" + UsuarioI + ")");
              } 
            else 
            {
               setUsuarioId(0);
               setTitulo("Adicionar Medico al Area");
            }
         }
     }, [show]);

     // Busca beneficiario
     const handleUsuario = async (query)=>{
    if (query.length > 3)
    {
      if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function(){
                    Procesar(query);
                    clearTimeout(timeout);
                  },1000);
    }
  }
  // procesa la busqueda
  const Procesar= async (query)=>
    {
       setActiva(true);
       const response = await getUsuarioFind(query);
       if (response)
       {
          if (response.status === 200) 
            {
               setData(response.data.data);
               setActiva(false);
            } 
          else 
          {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
          }  
          setActiva(false);
       }
    }

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
          <div className="flex lg:w-[25rem]">
              <form noValidate className="flex flex-col w-full">
                  <div className="flex flex-row w-full h-full ">
                     <div className="w-full">
                         <label>Area</label>
                         <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                             <option value="0" disabled>
                                 Seleccionar una Area...
                             </option>
                             {area.map((item) => {
                               return (
                                     <option key={item.AreaId} value={item.AreaId}>
                                       {item.NombreArea}
                                     </option>
                               );
                              })}
                         </select>
                         <div className="w-full mt-4">
                            <label>Profesional</label>
                              <input type="text" name='searchid' value={nombreMed || ""} placeholder="Buscar Usuarios..." 
                                     onKeyUp={(e) => handleUsuario(e.target.value.toUpperCase())}
                                     onChange={(e)=> setNombreMed(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2 || activa}></input>
                                <div className={ data.length >0 ? "block" : "hidden"}>
                                <table className="absolute z-10  bg-white border border-gray-300 rounded shadow-lg mt-1">
                        <thead className="border-b border-stone-200 text-sm font-medium ">
                           <tr>
                              <th className="px-2.5 py-2 text-start font-medium">Documento</th>
                              <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                              <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                           </tr>
                        </thead>
                        <tbody className="group text-sm text-stone-800 ">
                           {data.map((item) => (
                              <tr className="border-b border-stone-200 last:border-0" key={item.UsuarioId}  onClick={() => handlefilas(item)}>
                                 <td>{item.NumeroNit}</td>
                                 <td>{item.NombreUsr}</td>
                                 <td>{item.NombreCar}</td>
                              </tr>
                           ))}
                        </tbody>
                     </table>      
                  </div>
                         </div>
                      </div>   
                      
                  </div>
                  <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                      </div> 
              </form> 
          </div> 
          
    </Modal>          
    </>
  );
}
MedicoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  UsuarioI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default MedicoModal;
